
      document.querySelectorAll('.media-gallery.product__column-sticky').forEach(gallery => {
    const thumbnails = gallery.querySelector('[aria-label="Gallery Thumbnails"]');
    
    if (!thumbnails) {
        gallery.style.gridTemplateColumns = '1fr'; // main image full width
    } else {
        gallery.style.gridTemplateColumns = '0fr auto';
    }
});
